module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFdJREFUeNpifCuvwkAKYGIgEdBeAwsyhz0kCIiAjE8RMUCSb8USIPlzzTogwq6BSUaGxcIcIQdm/z5xapB7ms7B+u/Jkz8nTsK5EDZQEFkN4zBISwABBgDpQxnYdHU0jAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pause3.png
// module id = 620
// module chunks = 1 6